import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const PrivilegesConfigContext = createContext(null);

export const PrivilegesConfigProvider = ({ children }) => {
    const [privilegesConfig, setPrivilegesConfig] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = localStorage.getItem("vedhvidhi-admin-token");

    useEffect(() => {
        const fetchPrivilegesConfig = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/role-permissions`, {
                    headers: { Authorization: token },
                });

                if (response.data && response.data.success) {
                    setPrivilegesConfig(response.data.data || []);
                } else {
                    const errorMessage = "Failed to load permissions configuration from server.";
                    toast.error(errorMessage);
                    setError(errorMessage);
                    setPrivilegesConfig([]);
                }
            } catch (err) {
                const errorMessage = err.response?.data?.message || "An error occurred while fetching permissions config.";
                console.error("Error fetching privileges config:", err);
                toast.error(errorMessage);
                setError(errorMessage);
                setPrivilegesConfig([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPrivilegesConfig();
    }, [token]);

    const value = { privilegesConfig, loading, error };

    return (
        <PrivilegesConfigContext.Provider value={value}>
            {children}
        </PrivilegesConfigContext.Provider>
    );
};

export const usePrivilegesConfig = () => {
    const context = useContext(PrivilegesConfigContext);
    if (!context) {
        throw new Error('usePrivilegesConfig must be used within a PrivilegesConfigProvider');
    }
    return context;
};